import React from 'react';
import { useParams } from 'react-router-dom';
import { PDFExport } from '@progress/kendo-react-pdf';

import { Downloadble } from '../../downloadable';
import { AssessmentReport } from '../../../../components/assessment-report';
import { useGetAssessmentDocumentAndStateByReportId } from '../../../../hooks/services/use-reports';

export const DownloadableReport: React.FC = () => {
  const { eventId, detailId } = useParams();

  const pdfExport = React.useRef<PDFExport>(null);
  const [shouldFetch, setShouldFetch] = React.useState(false);

  const { document, state, teams, isLoading } =
    useGetAssessmentDocumentAndStateByReportId(
      eventId ?? '',
      detailId ?? '',
      shouldFetch
    );

  const onClick = () => {
    setShouldFetch(true);
  };

  React.useEffect(() => {
    if (shouldFetch && document && state && teams && !isLoading) {
      setTimeout(() => {
        if (pdfExport.current) {
          pdfExport.current.save();
          setShouldFetch(false);
        }
      }, 500);
    }
  }, [shouldFetch, document, state, teams, isLoading, pdfExport.current]);

  return (
    <>
      <Downloadble
        onClick={onClick}
        text={'Report'}
        icon={'assignment'}
        bgColor={'#707070'}
        disabled={isLoading}
        downloadText={isLoading ? 'Downloading' : 'Download PDF'}
      />

      {document && state && teams && (
        <AssessmentReport
          document={document}
          state={state}
          teams={teams}
          pdfExportRef={pdfExport}
        />
      )}
    </>
  );
};
